import React, { Component } from "react";
import Item from "./Item";

class ItemsList extends Component {

  render() {
    return (
      <div className="container">
        <div className="row">
          {this.props.items.map(item => {
            return (
              <div className="col-lg-4" key={item.idreg}>
                <Item item={item} 
                  addVote={this.props.addVote}
                  removeVote={this.props.removeVote} 
                  voteCount={this.props.voteCount}
                  votesLimit={this.props.votesLimit}/>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default ItemsList;
